export const MembersApi =
  process?.env?.REACT_APP_REPORTS_SERVICE_URL_DEFAULT ?? "https://reports.izettletest.com"

export const memberBaseApi = (path: string) => `${MembersApi}${path}`

// Paths

export const optinPostPath = (memberUuid: string) =>
  memberBaseApi(`/member/${memberUuid}/optin`)

export const memberMerchantGetPath = (memberUuid: string) =>
  memberBaseApi(`/member/${memberUuid}/merchant`)
